import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/tariffs/tariff.model';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PriceDetailsComponent } from './price-details.component';

interface SimpleTariffCardComponentProps {
  tariff: TariffModel;
}

export const SimpleTariffCardComponent = ({
  tariff,
}: SimpleTariffCardComponentProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // TODO: Should be moved in SDK
  const priceComponents = useMemo(
    () => tariff.elements[0]?.price_components ?? [],
    [tariff],
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card gap={GapEnum.M}>
      <AccentTitle
        as={HeadingEnum.H2}
        icon="price"
        text={t('$.emsp-bo-tariff-details.price.title')}
      />
      <PriceDetailsComponent
        currency={tariff.currency}
        priceComponents={priceComponents}
      />
    </Card>
  );
};
